import colors from './colors';

const foundations = {
  colors,
};

export default foundations;
